import React from "react";
import { Link } from "react-router-dom";
import { motion, useReducedMotion } from "framer-motion";
import { ArrowRightIcon } from "lucide-react";
import { projects } from "../data/projects";
import { ProjectCard } from "./ProjectCard";
import { SectionHeading } from "./SectionHeading";
import { H3 } from "../utils/typography";
const ease = [0.23, 1, 0.32, 1] as const;
export function ProjectsSection() {
  const reduce = useReducedMotion();
  // In-progress case studies live under In Progress, not in this grid
  const work = projects.filter(p => p.kind === "case-study" || p.kind === "reel");
  const invite = projects.find(p => p.kind === "invite");
  return <section id="projects" aria-labelledby="projects-heading" className="w-full scroll-mt-28 bg-cream px-6 pb-24 md:scroll-mt-36 md:px-12 md:pb-32 lg:px-20 lg:pb-40" data-id="element-390" data-mp="11mgdhza8u57u">
      <SectionHeading id="projects-heading" title="SELECTED RECENT WORK" data-id="element-391" data-mp="284uyycmu324g" />

      <div className="mt-24 grid grid-cols-1 gap-x-8 gap-y-14 md:mt-32 md:grid-cols-2 lg:mt-40" data-id="element-392" data-mp="2czs9jnzrhjjg">
        {work.map((project, i) => <motion.div key={project.id} className="h-full" initial={reduce ? false : {
        opacity: 0,
        y: 24
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.25
      }} transition={{
        duration: 0.3,
        ease,
        delay: i % 2 * 0.06
      }} data-id="element-393" data-mp="3507gjyq9ovwg" data-mpi={i}>
            <ProjectCard project={project} data-id="element-394" data-mp="2r0gbinhqapul" />
          </motion.div>)}
      </div>

      {invite && <motion.div className="mt-14 md:mt-20" initial={reduce ? false : {
      opacity: 0,
      y: 24
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true,
      amount: 0.25
    }} transition={{
      duration: 0.3,
      ease
    }} data-id="element-395" data-mp="2m8of3wbw5pwj">
          <Link to={invite.href}
      // Scroll even if the URL already ends in #contact (a repeat click wouldn't re-trigger)
      onClick={() => document.getElementById("contact")?.scrollIntoView({
        behavior: "smooth"
      })} className="group flex flex-col gap-6 rounded-3xl bg-espresso px-8 py-10 ring-offset-4 ring-offset-cream focus:outline-none focus-visible:ring-2 focus-visible:ring-rust md:flex-row md:items-center md:justify-between md:px-14 md:py-12" data-id="element-396" data-mp="28a89k8prm5fz">
            <div data-id="element-397" data-mp="1ondisrt5o7s1">
              <h3 className={`${H3} text-cream`} data-id="element-398" data-mp="1ooydqijdtsqf">{invite.title}</h3>
              <p className="mt-2 max-w-md text-cream/70" data-id="element-399" data-mp="2cdrcemre2eoq">{invite.description}</p>
            </div>
            <span className="flex h-12 shrink-0 items-center gap-2 self-start whitespace-nowrap rounded-full bg-rust px-6 text-sm font-medium uppercase text-cream transition-colors duration-150 ease-out group-hover:bg-mustard group-hover:text-espresso md:self-auto" data-id="element-400" data-mp="2hcax6ju8xkfi">
              {invite.cta}
              <ArrowRightIcon className="h-4 w-4 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-401" data-mp="2vclqrumxxd4d" />
            </span>
          </Link>
        </motion.div>}
    </section>;
}